module.exports = "https://web-phone.apps.phone.com/static/media/Montserrat-Regular.ee653992.ttf";